$(document).ready(function () {
    var body = $('html')

    function scroll_stop_message(element) {
        let footer = $('#shopify-section-footer'),
            scrollPosition = $(window).scrollTop(),
            stopper = footer.offset().top - 280,
            cover_pics = $('.cover-pics'),
            scrollPosition_without_footer = scrollPosition + footer.height(),
            coefficient = 0

        if (cover_pics.length >= 1) {
            stopper = cover_pics.offset().top - 220;
            scrollPosition_without_footer = scrollPosition + cover_pics.height() + footer.height()
            coefficient = 80
        }

        if (scrollPosition_without_footer >= stopper + coefficient) {
            element.css({
                'position': 'absolute',
                'top': stopper - 200
            });
        } else if (scrollPosition_without_footer < stopper) {
            element.css({
                'position': 'fixed',
                'top': '50%'
            });
        }
    }

    $(document).on('scroll', function (e) {
        let element1 = $('.left_message'),
            element2 = $('.right_message');

        scroll_stop_message(element1);
        scroll_stop_message(element2);
    })

 //    function updateCart() {
 //        setTimeout(function () {
 //            $("input[name='update']").trigger("click");
 //        }, 1000)
 //    }
 //
 //    $("input[name='updates[]']").on('input', function () {
 //        Updatecart();
 //    });
 //
 //  function Updatecart(updateData){
 //    $.ajax({
 //      type: 'POST',
 //      url: '/cart/update.js',
 //      data: {
 //        updates: updateData
 //      },
 //      dataType: 'json',
 //      success: function(cart){
 //          location.reload()
 //
 //      },
 //      error: function(err){ console.error('Booo!', err) }
 //    });
 //
 //  }
 // $(".cart-table .js-qty__adjust").on('click', function () {
 //     if($(this).hasClass('js-qty__adjust--minus'))
 //     {
 //       var updateData = {}
 //
 //       if($(this).siblings('input[type="text"]').val()==1){
 //         $(this).closest('.cart__row.table__section').find('td.cart__row--product-details a.cart__remove').trigger("click");
 //         var key=$(this).data('item-id');
 //         updateData[key] = 0;
 //         Updatecart(updateData);
 //       }else
 //         updateCart();
 //     }else
 //       updateCart();
 //   });

// Hide Header on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.site-header').outerHeight();

    // $(window).scroll(function(event){
    //     didScroll = true;
    // });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('header').removeClass('nav-down').addClass('nav-up');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $('header').removeClass('nav-up').addClass('nav-down');
            }
        }

        lastScrollTop = st;
    }


    function get_section_id($element)
    {
        return $(document).find($element).closest('.homepage-sections-wrapper').data('wetheme-section-id')
    }

    $('a.menu-slider').on('click', function (e) {
        e.preventDefault()

        let this_menu_item = $(this);
        let section_id = get_section_id(this_menu_item);
        let this_menu_number = $(this).data('menu');
        let container = $('#homepage-mega-slider-'+ section_id );
        let menu = $('#collection-slider-mega__menu-list-'+ section_id);

        menu.find('a.menu-slider').each(function (){
            $(this).removeClass('active')
        })

        this_menu_item.addClass('active')

        //
        container.find('.menu-list-slider__slide').each(function (){
            $(this).removeClass('active')
        });

        container.find('.menu-list-slider__slide-' + this_menu_number).addClass('active');

        $('.slider-'+ section_id).slick('refresh');

    })


    $(document).find('.custom-slider').each(function (){
        let slides_to_show =  $(this).data('slides');
        let dots =  $(this).data('dots');
        $(this).slick({
            infinite: true,
            slidesToShow: slides_to_show,
            slidesToScroll: slides_to_show,
            dots: dots,
            centerPadding: '40px',
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    })

    Fancybox.bind("[data-fancybox]", {
        infinite: true,
        carousel:false
    });

    $(document).on('click', '.open_promotion', function (){
        let grid = $(this).closest('.grid__item')

        grid.find('.collapse').slideToggle('slow');
        grid.find('.fa-plus').toggleClass('fa-minus')

    })

    // $(document).on('click','.add_to_cart_from_modal',function (e){
    //     e.preventDefault();
    //     console.log('sdfdsfsdf');
    //     Fancybox.close();
    //
    //     setTimeout(function (){
    //         $('body').find('form#AddToCartForm').submit();
    //     },1000)
    //
    // })

});

